import {
  COMPARE_HIERARCHIES,
  COMPARE_HIERARCHIES_SUCCESS,
  COMPARE_HIERARCHIES_ERROR,
  CLEAR_HIERARCHIES_RESULT,
} from '../constants/ActionsTypes'

const initialState = {
  loading: false,
  error: null,
  results: [],
  metadata: null,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case COMPARE_HIERARCHIES:
      return { ...state, loading: true, error: null, results: [], metadata: null }
    case COMPARE_HIERARCHIES_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload.data || [],
        metadata: action.payload.metadata || null,
      }
    case COMPARE_HIERARCHIES_ERROR:
      return { ...state, loading: false, error: action.payload }
    case CLEAR_HIERARCHIES_RESULT:
      return { ...initialState }
    default:
      return state
  }
}

export default rootReducer
